<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="图标" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img
              v-if="form.avatar"
              :src="form.avatar"
              :class="['avatar', form.avatarSize === 1 ? 'large' : '']"
            />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>
            建议尺寸：{{
              form.avatarSize === 1 ? '343px * 164px' : '167px * 167px'
            }}
          </span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close(formRef)">取 消</el-button>
        <el-button type="primary" @click="save(formRef)">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { updateModel, createModel } from '@/api/model'
import { ref, reactive, getCurrentInstance } from 'vue'
 import { QNUploadURL, QNHost } from '@/config/net.config'
 import { getUploadToken } from '@/api/app'

export default {
  name: 'OaCarEdit',
  emits: ['fetch-data'],
  setup(_, { emit }) {
    const uploadToken=ref()

    const { proxy } = getCurrentInstance()
    const title = ref('')
    const dialogFormVisible = ref(false)
    const formRef = ref(null)
    const initForm = () => {
      return {
        modelId: '',
        title: '',
        avatar: '',
      }
    }
    const form = reactive(initForm())
    const rules = {
      title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
      avatar: [{ required: true, trigger: 'blur', message: '请选择图标' }],
    }
    const image_remove=(file, fileList)=> {
      form.avatar = ''
    }
    const image_success=(res, file) =>{
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      form.avatar = `${QNHost}/${res.hash}`
    }
    const showEdit = async (row) => {
      if (row && row.modelId) {
        console.log(row,'row');
        title.value = '修改model'
        form.modelId = row.modelId
        form.title = row.title
        form.avatar = row.basic.avatar
      } else {
        title.value = '新增model'
      }
      const token = await getUploadToken({})
      uploadToken.value = { token: token.token }
      dialogFormVisible.value = true
    }
    const formReset = (formRef) => {
      if (!formRef) return
      formRef.resetFields()
      Object.assign(form,initForm())
    }
    const close = (formRef) => {
      formReset(formRef)
      dialogFormVisible.value = false
    }
    const save = (formRef) => {
      if (!formRef) return
      formRef.validate(async (valid) => {
        if (valid) {
          const modelId = form.modelId
          const data = Object.assign({}, form)
          proxy.$baseConfirm(
            `你确定要${modelId ? '修改' : '新增'}model吗`,
            null,
            async () => {
              modelId
                ? await updateModel(data)
                : await createModel(data)
              proxy.$baseMessage(
                `${modelId ? '修改' : '新增'}model成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              emit('fetch-data')
              close(formRef)
            }
          )
        } else {
          return false
        }
      })
    }
    return {
      title,
      formRef,
      form,
      rules,
      dialogFormVisible,
      QNUploadURL,
      uploadToken,
      image_success,
      image_remove,
      showEdit,
      close,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
